import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../../web/ReactQueryProvider';
import { timeEntryKeys } from './keys';
import { ITimeEntryEvent } from './types';

export function useTimeEntryHistoryQuery({ id, enabled = true }: { id?: string; enabled?: boolean }) {
	const userSession = useUserSession();
	return useQuery({
		queryKey: timeEntryKeys.history(id ?? ''),
		queryFn: () =>
			userSession.webServiceHelper.callAsync<ITimeEntryEvent[]>(`TimeEntry/${encodeURIComponent(id)}/history`, 'GET'),
		enabled: enabled && !!id,
		meta: {
			toastErrorMessage: 'Failed to load history',
			errorLogging: { action: 'TimeEntryHistoryQuery-Error', category: 'TimeEntry' },
		} satisfies LevStandardQueryMeta,
	});
}
